import * as styles from "./styles.ts";
import { Flex } from "src/components/Flex.tsx";
import { ButtonV2 } from "src/components/ButtonV2/ButtonV2.tsx";
import { B2bGateLogo } from "src/assets";
import { loadTranslations } from "src/lib/i18next/loadTranslations.ts";
import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";
import { useTranslation } from "react-i18next";
import { useDataRouterContext } from "src/lib/react-router/useDataRouterContext.ts";
import { routePaths as orderRoutePaths } from "src/admin/modules/order/constants.ts";
import { routePaths as productRoutePaths } from "src/admin/modules/product/constants.ts";
import { useClientConfig } from "src/client-config/useClientConfig.ts";
import { AppVariation } from "src/client-config/getClientConfig.ts";
import { css } from "@emotion/react";
import type { ExactTheme } from "src/lib/emotion/theme.ts";

await loadTranslations(TranslationNamespaceEnum.B2BGateEmptyScreen);

export const B2BGateEmptyScreen = () => {
  const { t } = useTranslation(TranslationNamespaceEnum.B2BGateEmptyScreen);
  const { router } = useDataRouterContext();
  const clientConfig = useClientConfig();

  if (clientConfig.appVariation !== AppVariation.B2bGateSupplier) {
    return;
  }

  return (
    <div css={styles.container}>
      <Flex flexDirection={"column"} gap={30} alignItems={"center"}>
        <B2bGateLogo />
        <span>{t("title")}</span>
        <Flex gap={15}>
          <ButtonV2
            style={{ height: "60px", width: "250px" }}
            startAdornment={<i css={iconStyle} className={"icon-20-box-alt"} />}
            skin={"info"}
            variant={"filled"}
            onClick={() => router.navigate(productRoutePaths.root)}
            css={fontStyle}
          >
            {t("moduleName.product", {
              ns: TranslationNamespaceEnum.Common,
            })}
          </ButtonV2>
          <ButtonV2
            style={{ height: "60px", width: "250px" }}
            startAdornment={
              <i css={iconStyle} className={"icon-20-custm_ord"} />
            }
            skin={"info"}
            variant={"filled"}
            onClick={() => router.navigate(orderRoutePaths.root)}
            css={fontStyle}
          >
            {t("moduleName.customer-orders", {
              ns: TranslationNamespaceEnum.Common,
            })}
          </ButtonV2>
        </Flex>
      </Flex>
    </div>
  );
};

const iconStyle = css`
  font-size: 20px;
`;
const fontStyle = (theme: ExactTheme) => css`
  font-size: ${theme.fontSizesV2.h5};
`;
